import Desktop from "./screen-view/Desktop";
import Mobile from "./screen-view/Mobile";

export default function SectionFive() {
  return (
    <section
      className="section-five bg-gradient-to-b from-customBlue-dark to-customBlue"
      id="section-5"
    >
      <Desktop />
      <Mobile />
    </section>
  );
}
